import { idConfig } from '@glowforge/builder-components/lib/util/shared-configs';

/**
 * @type {import('@builder.io/sdk/dist/src/builder.class').Component}
 */
export default {
  name: 'GoogleSignIn',
  friendlyName: 'Google Sign In',
  image: 'https://cdn.builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be67c2d7639c2',
  description: 'Google Sign In / Sign Up button that authenticates via user-service',
  inputs: [
    idConfig,
    {
      name: 'allowCreate',
      type: 'boolean',
      defaultValue: false,
      // eslint-disable-next-line max-len
      helperText: 'Allow new account creation via Google (shows "Sign up with Google" instead of "Sign in")',
    },
    {
      name: 'redirectUrl',
      type: 'string',
      helperText: 'URL to redirect to after sign in. Leave empty to redirect back to current page.',
    },
  ],
};
